// extracted by mini-css-extract-plugin
export default {"cookieBanner":"CookieNoticeBanner_cookieBanner__EDuc2","bannerBody":"CookieNoticeBanner_bannerBody__9EoNY","close":"CookieNoticeBanner_close__HLi2A"};